// src/services/companyResourceService.js
const APPSYNC_URL = process.env.REACT_APP_APPSYNC_API_URL; // set this in env
if (!APPSYNC_URL) console.warn('Missing REACT_APP_APPSYNC_API_URL');

async function appsyncRequest(query, variables) {
  const idToken = localStorage.getItem('id_token');
  if (!idToken) throw new Error('Missing id_token');

  const res = await fetch(APPSYNC_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: idToken,
    },
    body: JSON.stringify({ query, variables }),
  });

  const data = await res.json().catch(() => ({}));
  if (data?.errors?.length) throw new Error(data.errors[0]?.message || 'AppSync error');
  return data?.data;
}

const Q_LIST_BY_COMPANY = /* GraphQL */ `
query CompanyResourcesByCompany($companyId: ID!, $limit: Int, $nextToken: String) {
  companyResourcesByCompany(companyId: $companyId, limit: $limit, nextToken: $nextToken) {
    items { id companyId name type url description createdByUserId createdAt updatedAt }
    nextToken
  }
}
`;

const Q_GET = /* GraphQL */ `
query GetCompanyResource($id: ID!) {
  getCompanyResource(id: $id) {
    id companyId name type url description createdByUserId createdAt updatedAt
  }
}
`;

const M_CREATE = /* GraphQL */ `
mutation CreateCompanyResource($input: CreateCompanyResourceInput!) {
  createCompanyResource(input: $input) {
    id companyId name type url description createdByUserId createdAt updatedAt
  }
}
`;

const M_UPDATE = /* GraphQL */ `
mutation UpdateCompanyResource($input: UpdateCompanyResourceInput!) {
  updateCompanyResource(input: $input) {
    id companyId name type url description createdByUserId createdAt updatedAt
  }
}
`;

const M_DELETE = /* GraphQL */ `
mutation DeleteCompanyResource($input: DeleteCompanyResourceInput!) {
  deleteCompanyResource(input: $input) {
    id
  }
}
`;

const CompanyResourceService = {
  listByCompany: async ({ companyId, limit = 50, nextToken = null }) => {
    const data = await appsyncRequest(Q_LIST_BY_COMPANY, { companyId, limit, nextToken });

    const conn = data?.companyResourcesByCompany || { items: [], nextToken: null };

    // AppSync can return nulls in items; strip them so UI never crashes
    const safeItems = Array.isArray(conn.items) ? conn.items.filter(Boolean) : [];

    return { ...conn, items: safeItems };
  },

  get: async (id) => {
    const data = await appsyncRequest(Q_GET, { id });
    return data?.getCompanyResource || null;
  },

  create: async (input) => {
    const data = await appsyncRequest(M_CREATE, { input });
    return data?.createCompanyResource;
  },

  update: async (input) => {
    const data = await appsyncRequest(M_UPDATE, { input });
    return data?.updateCompanyResource;
  },

  remove: async (id) => {
    const data = await appsyncRequest(M_DELETE, { input: { id } });
    return data?.deleteCompanyResource;
  },
};

export default CompanyResourceService;